import styled from 'styled-components';

export const DivFormTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;